<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-26 18:19:29
 * @Description: 设备信息
 * @LastEditors: Please set LastEditors
-->
<template>
  <div
    v-drag
    :class="setSemitransparent ? 'semitransparent' : ''"
    class="h-100 position-absolute equpment"
  >
    <span
      class="iconfont icon-close cur-pointer position-absolute close_icon"
      @click="closeDialog"
    ></span>
    <el-tabs :tab-position="tabPosition" class="equpment_tabs p-t-20 h-100 w-100">
      <el-tab-pane label="设备台账">
        <DeviceLedger class="h-100"></DeviceLedger>
      </el-tab-pane>
      <el-tab-pane label="管道数据">
        <PipelineData class="h-100"></PipelineData>
      </el-tab-pane>
      <el-tab-pane label="设备缺陷">
        <EquipmentDefects class="h-100"></EquipmentDefects>
      </el-tab-pane>
      <el-tab-pane label="工单信息"></el-tab-pane>
      <el-tab-pane label="检修记录"></el-tab-pane>
      <el-tab-pane label="两票-工作票">
        <TwoVotes></TwoVotes>
      </el-tab-pane>
      <el-tab-pane label="两票-操作票">
        <TwoVotes class="h-100"></TwoVotes>
      </el-tab-pane>
      <el-tab-pane label="运行日常工作"></el-tab-pane>
      <el-tab-pane label="设备异动记录"></el-tab-pane>
      <el-tab-pane label="工器具登记"></el-tab-pane>
      <el-tab-pane label="工器具借出归还"></el-tab-pane>
      <el-tab-pane label="消防和防汛物资"></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// 设备台账
const DeviceLedger = () => {
  return import('./components/DeviceLedger')
}
// 管道数据查看
const PipelineData = () => {
  return import('./components/PipelineData')
}
// 设备缺陷管理
const EquipmentDefects = () => {
  return import('./components/EquipmentDefects')
}
// 两票集成
const TwoVotes = () => {
  return import('./components/TwoVotes')
}
export default {
  props: ['setSemitransparent'],
  components: {
    DeviceLedger,
    PipelineData,
    EquipmentDefects,
    TwoVotes,
  },
  data() {
    return {
      fromData: {},
      tabPosition: 'left',
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeComponents')
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/semitransparent.scss';
.equpment {
  height: 600px;
  width: 900px;
  top: 48px;
  background-color: #ffffff;
  border-radius: 4px;
  z-index: 99;
}
/deep/.el-form-item {
  margin-bottom: 5px;
}
/deep/.el-tabs__content,
/deep/.el-tab-pane {
  height: 100%;
}
/deep/ .el-table {
  thead th {
    padding: 0px;
  }
  &__body-wrapper {
    height: calc(100% - 25px);
    overflow-y: scroll;
  }
  &__expanded-cell {
    padding: 0px 10px;
    padding-left: 20px;
  }
}
.close_icon {
  top: 5px;
  right: 12px;
  z-index: 1;
}

</style>
